import { create } from "zustand";
import { api } from "@/services/api.service";

export type PaginateNotificationResp = {
  status: boolean;
  data: Notification[];
  pagination: {
    page: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
    currentPage: number;
  };
  message: string;
};

export type Notification = {
  id: string;
  title: string;
  time: string;
  message: string;
  icon?: string;
  isRead: boolean;
  publishedAt: string;
};

export type NotificationStore = {
  notifications: Notification[];
  page: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  currentPage: number;
  loading: boolean;
  error: string | null;
  fetchNotifications: (page?: number, pageSize?: number) => void;
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
};

const useNotificationStore = create<NotificationStore>((set) => ({
  notifications: [],
  page: 1,
  pageSize: 5,
  totalRecords: 0,
  totalPages: 0,
  currentPage: 1,
  loading: false,
  error: null,

  fetchNotifications: (page = 1, pageSize = 5) => {
    const config = {
      params: { page, pageSize },
    };

    set({ loading: true, error: null });
    api
      .get<PaginateNotificationResp>("/profile/notifications", config)
      .then((response) => {
        const resp = response.data as PaginateNotificationResp;
        set({
          notifications: resp.data, // Set the notifications array from data.data
          page: resp.pagination.page,
          pageSize: resp.pagination.pageSize,
          totalRecords: resp.pagination.totalRecords,
          totalPages: resp.pagination.totalPages,
          currentPage: resp.pagination.currentPage,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        set({ error: error.message, loading: false });
      });
  },

  markAsRead: (id: string) => {
    set((state) => ({
      notifications: state.notifications.filter((notif) => notif.id !== id),
    }));
  },

  markAllAsRead: () => {
    set(() => ({
      notifications: [],
    }));
  },
}));

export default useNotificationStore;
